export default "__VITE_ASSET__43794c72__"